import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { ShipmentConfigurationService } from '../../services/shipping-configuration-service';

export const useIsFedexHALBySalesOrderId = (salesOrderId) => {
  const requestedService = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'requestedService',
    }),
  );
  return ShipmentConfigurationService.isFedexHal(requestedService);
};

export const useIsFedexHALByFulfillmentPlanId = (fulfillmentPlanId) => {
  const salesOrderId = useSelector((state) =>
    Global.selectEntitiesSalesOrderIdsByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    }),
  );
  return useIsFedexHALBySalesOrderId(salesOrderId[0]);
};
